/*
 * The number represents the priority
 */
export enum FormStateEnum {

  EMPTY = -1,
  NONE = 0,
  SUCCESS = 1,
  CHANGED = 2,
  WORKING = 3,
  ERROR = 4,
}
